import { LOGO_URL, SUPPORT_EMAIL } from "../constants/brand";
import { TrustPortalWatermark } from "../components/shared/TrustPortalWatermark";

export default function TrustPortalComingSoonPage() {
  return (
    <div className="min-h-screen bg-auth-bg flex items-center justify-center p-6 relative overflow-hidden" data-testid="trust-portal-coming-soon-page">
      <TrustPortalWatermark />
      <div className="text-center relative z-10 max-w-lg">
        <img src={LOGO_URL} alt="Iron Gate Consulting" className="w-24 h-24 object-contain mb-6 mx-auto auth-glow" />
        <h1 className="font-serif text-3xl text-auth-cream tracking-tight mb-3">The Trust Portal Is Moving Here</h1>
        <p className="text-auth-muted text-sm leading-relaxed">
          trust.igchq.com is being finalized. Your living trust and asset protection intake will be available on this
          address shortly — personal call before you pay, military legal review included.
        </p>
        <p className="text-center text-xs text-auth-muted mt-10">Need help now? <span className="text-auth-gold">{SUPPORT_EMAIL}</span></p>
      </div>
    </div>
  );
}
